import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const MAIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="MA" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#C51918"
        fillRule="evenodd"
        d="M0 0h16v11a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E31D1C"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#579D20"
        d="M11.241 9.813 8.064 7.911 4.898 9.813 7.945 1.35h.138l3.158 8.463ZM7.734 4.111 6.718 6.95 6.14 8.346l1.25-.906.672-.404.683.41 1.28.9-.593-1.369-1.01-2.828-.352-1.357-.337 1.32Z"
      />
      <Path
        fill="#579D20"
        d="M9.71 6.736 8.08 7.898 6.33 6.736 3.193 4.118h9.615L9.71 6.736Zm-3.343-.999 1.705 1.207L9.77 5.656l1.02-.646H5.18l1.188.727Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
